import { login, logout, getInfo, fetchRoleMenu } from '@/api/user'
import {
  getToken,
  setToken,
  removeToken,
  storageSetItem,
  StorageUserInfoKey,
} from '@/utils/auth'
import { resetRouter } from '@/router'

const getDefaultState = () => {
  return {
    token: getToken(),
    name: '',
    avatar: '',
    userInfo: '',
  }
}

const state = getDefaultState()

const mutations = {
  RESET_STATE: (state) => {
    Object.assign(state, getDefaultState())
  },
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_USER_INFO: (state, data) => {
    state.userInfo = data
    storageSetItem(StorageUserInfoKey, JSON.stringify(data))
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, authCode } = userInfo
    return new Promise((resolve, reject) => {
      login({
        username: username.trim(),
        password: password,
        authCode: authCode,
      })
        .then((response) => {
          const { data } = response

          let userData = data.user_info

          if (typeof userData == 'string') {
            userData = JSON.parse(userData)
          }

          commit('SET_USER_INFO', userData)
          commit('SET_TOKEN', data.token)
          setToken(data.token)
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // get user info
  getInfo({ commit, state, rootGetters }) {
    return new Promise((resolve, reject) => {
      // getInfo(state.token)
      //   .then((response) => {
      //     const { data } = response

      //     if (!data) {
      //       return reject('鉴权失败，请重新登录')
      //     }

      //     const { name, avatar } = data

      //     commit('SET_NAME', name)
      //     commit('SET_AVATAR', avatar)
      //     resolve(data)
      //   })
      //   .catch((error) => {
      //     reject(error)
      //   })

      let userInfo = rootGetters.userInfo
      if (!userInfo) {
        return reject('鉴权失败，请重新登录')
      }
      let username = ''

      if (Array.isArray(userInfo)) {
        username = userInfo[0]['username']
        userInfo = userInfo[0]
      } else {
        username = userInfo.username
      }

      commit('SET_NAME', username)
      resolve(userInfo)
    })
  },

  // user logout
  logout({ commit, state, rootGetters }) {
    return new Promise((resolve, reject) => {
      logout(state.name)
        .then(() => {
          removeToken() // must remove  token  first
          resetRouter()
          commit('RESET_STATE')
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise((resolve) => {
      removeToken() // must remove  token  first
      commit('RESET_STATE')
      resolve()
    })
  },
  //获取菜单权限
  getRoleMenu({ commit, state }) {
    return new Promise((resolve) => {
      fetchRoleMenu().then((res) => {
        // console.log(res)
        let auths = []
        if (res.result == 'true') {
          let data = res.data || {}
          auths = data.menuIdent || []
        }
        resolve(auths)
      })
    })
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
